import { render } from "./zcfzTable4.vue?vue&type=template&id=a4283ce8&scoped=true"
import script from "./zcfzTable4.vue?vue&type=script&lang=js"
export * from "./zcfzTable4.vue?vue&type=script&lang=js"

import "./zcfzTable4.vue?vue&type=style&index=0&id=a4283ce8&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4283ce8"]])

export default __exports__